// extracted by mini-css-extract-plugin
export default {"grey":"icons_grey__WhFKC"};